var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QuestionEditor',{attrs:{"payload":{ question: _vm.question, resource_type: 'Position', resource_id: _vm.payload.resource_id }}}),_c('br'),_c('GhanaFlag',{attrs:{"payload":_vm.payload.resources.position,"additional_data":{ resource_type: 'Position' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }